export const EPOCHS_SECS = 'EpochSecs';
export const EPOCHS_MILLIS = 'EpochMillis';
export const MERGE_PARAM = 'MergeParam';

export type CastType = typeof EPOCHS_SECS | typeof EPOCHS_MILLIS | typeof MERGE_PARAM;
